import { Stack, Typography } from '@mui/material'
import React from 'react'
import { useIntl } from 'react-intl'
import type { BenchmarkGroupType } from '@app/src/types/benchmark'
import type { KpiMessage, PeerComparison } from '../benchmark/kpiCardLogic'

export const useBenchmarkMeanLine = (
  peerGroup: BenchmarkGroupType,
  comparison?: PeerComparison,
): string | undefined => {
  const { formatMessage, formatNumber } = useIntl()
  if (!comparison) return undefined
  return formatMessage(
    { id: 'sustainabilityProfile.kpi.groupAverage' },
    { group: peerGroup, mean: formatNumber(comparison.mean, { maximumFractionDigits: 1 }) },
  )
}

interface KpiComparisonTextProps {
  meanLine?: string
  status?: KpiMessage
  isMuted?: boolean
}

const KpiComparisonText: React.FC<KpiComparisonTextProps> = ({ meanLine, status, isMuted = false }) => {
  const { formatMessage } = useIntl()
  if (!meanLine && !status) return null

  return (
    <Stack flexGrow={1} justifyContent="flex-end">
      {meanLine && (
        <Typography variant="caption" color={isMuted ? 'text.secondary' : 'text.primary'}>
          {meanLine}
        </Typography>
      )}
      {status && (
        <Typography variant="caption" color="text.secondary">
          {formatMessage({ id: status.id }, status.values)}
        </Typography>
      )}
    </Stack>
  )
}

export default KpiComparisonText
